import api from '../token';

export const ListNacionalidade = async () => {
  try {
    const response = await api.post('/getNacionalidade');
    return response.data;
  } catch (error) {
    
    return [];
  }
};

